import { useContext } from 'react'
import {
  Box,
  Stack,
  TextField,
  Typography,
  Divider,
} from '@mui/material'

import SwipeableDrawerRightDialog from '../../../../../components/Dialogs/SwipeableDrawerRightDialog'
import { AuthContext } from '../../../../../core/context/AuthContext'
import { TProductTicket } from '../../../../../core/types/Tickets'
import TicketsFunctions from './TicketsFunctions'


export interface IProductTicketDetailProps {
  open: boolean
  setOpen: (value: boolean) => void
  ticket: TProductTicket
}

const ProductTicketDetail = ({
  open,
  setOpen,
  ticket,
}: IProductTicketDetailProps) => {
  const { isUserSysAdmin } = useContext(AuthContext)
  const isAdmin = isUserSysAdmin()
  const statusStyles = TicketsFunctions.getStatusChipStyles(ticket.status)

  return (
    <SwipeableDrawerRightDialog
      open={open}
      onClose={() => setOpen(false)}
      setOpen={setOpen}
      title="Detalhes do Ingresso"
      subtitle="Visualize as informações do ingresso vendido."
      buttons={[
        {
          title: 'Fechar',
          onClick: () => setOpen(false),
          type: 'negative',
        },
      ]}
      buttonsDisabled={false}
    >
      <Box sx={{ width: '100%', px: 2, py: 1 }}>
        <Stack direction="column" spacing={3}>

          {/* Status */}
          <Stack direction="row" alignItems="center" spacing={1}>
            <Typography fontWeight={600} color="#343948">
              Status:
            </Typography>
            <Box
              sx={{
                borderRadius: '16px',
                px: 1.5,
                py: 0.5,
                backgroundColor: statusStyles.backgroundColor,
                color: statusStyles.color,
                fontSize: '13px',
                fontWeight: 600,
              }}
            >
              {TicketsFunctions.getStatusLabel(ticket.status)}
            </Box>
          </Stack>

          <Divider />

          {/* Dados do pedido */}
          <Stack direction="column" spacing={2}>
            <Typography
              fontWeight={600}
              fontSize="14px"
              lineHeight="18px"
              color="#343948"
            >
              Dados da compra
            </Typography>

            <TextField
              fullWidth
              size="small"
              disabled
              label="Código do Pedido"
              value={ticket.orderCode}
            />

            <TextField
              fullWidth
              size="small"
              disabled
              label="Oferta"
              value={ticket.offerName}
            />

            <TextField
              fullWidth
              size="small"
              disabled
              label="Comprador"
              value={ticket.buyerName}
            />

            <TextField
              fullWidth
              size="small"
              disabled
              label="E-mail do comprador"
              value={ticket.buyerEmail}
            />

            {ticket.tierTitle && (
              <TextField
                fullWidth
                size="small"
                disabled
                label="Lote / Tipo"
                value={ticket.tierTitle}
              />
            )}

            {ticket.ticketSection && (
              <TextField
                fullWidth
                size="small"
                disabled
                label="Setor"
                value={ticket.ticketSection}
              />
            )}
          </Stack>

          <Divider />

          {/* Dados do portador */}
          <Stack direction="column" spacing={2}>
            <Typography
              fontWeight={600}
              fontSize="14px"
              lineHeight="18px"
              color="#343948"
            >
              Portador do ingresso
            </Typography>

            <TextField
              fullWidth
              size="small"
              disabled
              label="Nome do portador"
              value={ticket.holderName ?? ''}
            />

            <TextField
              fullWidth
              size="small"
              disabled
              label="E-mail do portador"
              value={ticket.holderMail ?? ''}
            />

            <TextField
              fullWidth
              size="small"
              disabled
              label="Telefone"
              value={ticket.holderPhone ?? ''}
            />

            <TextField
              fullWidth
              size="small"
              disabled
              label="Documento"
              value={ticket.holderDocument ?? ''}
            />
          </Stack>
        </Stack>
      </Box>
    </SwipeableDrawerRightDialog>
  )
}

export default ProductTicketDetail
